export default __webpack_public_path__ + "static/media/pse.48fd1e53.png";